(function (global) {
  var CONTROL_CHARACTERS = /[\u0000-\u001f\u007f]/;
  var VALIDATION_BASE = "https://return-path.invalid";
  var LINK_SELECTOR = "[data-google-customer-auth-link]";

  function isSafeReturnPath(value) {
    if (typeof value !== "string" || value.length === 0) return false;
    if (value.indexOf("\\") !== -1) return false;
    if (CONTROL_CHARACTERS.test(value)) return false;
    if (value.charAt(0) !== "/" || value.charAt(1) === "/") return false;

    try {
      var resolved = new URL(value, VALIDATION_BASE);
      return resolved.origin === VALIDATION_BASE && resolved.pathname.charAt(0) === "/";
    } catch (error) {
      return false;
    }
  }

  function readReturnUrl(search) {
    var value = new URLSearchParams(search || "").get("return_url");
    return isSafeReturnPath(value) ? value : null;
  }

  function buildAuthHref(href, returnUrl) {
    var base = (global.location && global.location.origin) || VALIDATION_BASE;
    var authUrl = new URL(href, base);
    authUrl.searchParams.set("return_to", returnUrl);
    return authUrl.pathname + authUrl.search + authUrl.hash;
  }

  function applyReturnUrl(document, search) {
    if (!document || typeof document.querySelectorAll !== "function") return;

    var returnUrl = readReturnUrl(search);
    if (!returnUrl) return;

    var links = document.querySelectorAll(LINK_SELECTOR);
    for (var index = 0; index < links.length; index++) {
      links[index].href = buildAuthHref(links[index].href, returnUrl);
    }
  }

  global.GoogleCustomerAuth = {
    isSafeReturnPath: isSafeReturnPath,
    readReturnUrl: readReturnUrl,
    buildAuthHref: buildAuthHref,
    applyReturnUrl: applyReturnUrl,
  };

  // The snippet can render more than once per page, so initialization runs a single time
  // and updates every rendered link.
  if (global.googleCustomerAuthInitialized) return;
  global.googleCustomerAuthInitialized = true;

  var document = global.document;
  if (!document) return;

  function initialize() {
    applyReturnUrl(document, global.location && global.location.search);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize);
  } else {
    initialize();
  }
})(typeof window !== "undefined" ? window : globalThis);
